import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../core/auth/auth-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormControl, Validators } from '@angular/forms';
import { MyErrorStateMatcher } from '../../utils/errorStateMatcher';
import { ActionsService } from '../../services/actions.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

import { ReactiveFormsModule } from '@angular/forms';
import { MainContent } from '../../services/main-content.service';
import { Subject, takeUntil, interval, take } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { SigningScreenComponent } from '../signing-screen/signing-screen';
import { TranslateModule } from '@ngx-translate/core';


const uniqueID = window.crypto.randomUUID();

// const uniqueID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
//   const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
//   return v.toString(16);
// });

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  styleUrls: ['./login.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatFormFieldModule, MatSelectModule, MatOptionModule, MatCheckboxModule, MatMenuModule, MatIconModule, ReactiveFormsModule, MatInputModule, SigningScreenComponent, TranslateModule],
})
export class LoginComponent implements OnInit, OnDestroy {
  email: FormControl = new FormControl('', [Validators.required]);
  password: FormControl = new FormControl('', [Validators.required]);
  matcher = new MyErrorStateMatcher();

  notRegistered: any;
  emailParam?: string;
  remember?: boolean;
  errorMessage?: string;
  domain_selected?: string;
  domains?: string[];
  tokens?: string[];

  selected = 'NL';
  language: string = 'nl';
  showContent: boolean = false;

  emailStep: 'main' | 'inputEmail' | 'inputCode' = 'main';
  emailInput: FormControl = new FormControl('', [Validators.required, Validators.email]);
  codeInput: FormControl = new FormControl('', [Validators.required]);

  emailOptions: string[] = [];
  selectedEmail: string = '';

  showSigningScreen: boolean = false;
  downloadId: string = '';

  resendCooldown: number = 0;
  private resendCooldownSeconds: number = 30;


  files: any[] = [];
  sharedBy: string = '';
  subject: string = '';
  type: string = '';
  namespace: string = '';


  private destroy$ = new Subject<void>();

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private http: HttpClient,
    private actionsService: ActionsService,
    private cookieService: CookieService,
    private mainContentService: MainContent,
    private route: ActivatedRoute,
  ) {
    this.language = this.cookieService.get('language');
    this.changeLanguage(this.language);
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.downloadId = params.get('id') || '';
    });

    var url = new URL(window.location.href);

    if (!this.downloadId) {
      const hostname = window.location.hostname.toLowerCase();
      if (hostname.includes('sign')) {
        this.type = 'Sign';
      } else {
        this.type = 'Download';
      }
    }


    if (sessionStorage.getItem('authToken')) {
      this.showSigningScreen = true;
      this.showContent = true;
    } else {
      this.showSigningScreen = false;
    }

    if (this.authService.getToken()) {
      this.showContent = true;
      this.showSigningScreen = true;
    } else {
      var url = new URL(window.location.href);
      this.showContent = true;
      this.notRegistered = url.searchParams.get('notRegistered');
      this.emailParam = url.searchParams.get('email') ?? undefined;

      const domainsParam = url.searchParams.get('domains');
      const tokensParam = url.searchParams.get('tokens');

      if (domainsParam && tokensParam) {
        this.domains = domainsParam.split(',').filter((s) => s !== '');
        this.tokens = tokensParam.split(',').filter((s) => s !== '');

        // Find in domains the index of one named 'support'
        const supportDomainIndex = this.domains.findIndex((domain) => domain.toLowerCase() === 'support');

        // If found, remove it from both list, domains and tokens
        if (supportDomainIndex !== -1) {
          this.domains.splice(supportDomainIndex, 1);
          this.tokens.splice(supportDomainIndex, 1);
        }
      }
      else if (tokensParam && !domainsParam) {
        this.tokens = tokensParam.split(',').filter((s) => s !== '');
        sessionStorage.setItem('authToken', this.tokens[0]);

        this.router.navigateByUrl(`/${this.downloadId}`);
        window.location.href = `/${this.downloadId}`;
        this.showSigningScreen = true;
      }

      const typeParam = url.searchParams.get('type');

      if (!this.domains && !this.tokens && typeParam !== 'dev') {
        if (typeParam === 'Google' || typeParam === 'Office') {
          this.login(typeParam);
          return;
        }
      }

      if (this.notRegistered != null) {
        if (this.emailParam) {
          const message = this.translate.instant(`is not registered`);
          this.actionsService.set({ type: 'notification', status: 'none', message: `❌ ${this.emailParam} ` + message });
        } else {
          const message = this.translate.instant(`You are not registered`);
          this.actionsService.set({ type: 'notification', status: 'none', message: `❌ ` + message });
        }
      }
    }

    if (!this.showSigningScreen) {
      this.loadFiles();
    }

  }

  loadFiles(): void {

    if (this.downloadId) {
      this.mainContentService.viewDownloadPublic(this.downloadId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (fileResponse: any) => {
            this.sharedBy = fileResponse.user;
            this.subject = fileResponse.subject;
            this.files = fileResponse.files || [];
            this.type = fileResponse.type
            this.namespace = fileResponse.namespace;

            this.emailOptions = (fileResponse.accesses || [])
              .filter((access: any) => access.userType === 'email')
              .map((access: any) => access.id);


            if (this.domains && this.domains.length > 0 && this.namespace) {
              this.domain_selected = this.namespace;
              this.continue();
            }

          },
          error: (error: any) => {
            console.error('Error loading files:', error);
          }
        });
    }




  }


  login(type: string) {
    this.authService.login(type, this.remember ?? false);
  }

  submitFirebase() {
    this.errorMessage = '';
    this.authService
      .authenticateFirebase(this.email.value, this.password.value)
      .then((value) => { })
      .catch((value) => {
        this.actionsService.set({ type: 'notification', status: 'none', message: '❌ ' + value });
      });
  }

  continue() {
    if (!this.domains || !this.tokens || !this.domain_selected) return;
    const index = this.domains.indexOf(this.domain_selected);

    if (index !== -1 && this.tokens[index]) {
      sessionStorage.setItem('authToken', this.tokens[index]);
      this.router.navigateByUrl(`/${this.downloadId}`);
      window.location.href = `/${this.downloadId}`;
    }
    else {
      const externalIndex = this.domains.findIndex((d) => d.toLowerCase() === 'external');
      if (externalIndex !== -1 && this.tokens[externalIndex]) {
        sessionStorage.setItem('authToken', this.tokens[externalIndex]);

        this.router.navigateByUrl(`/${this.downloadId}`);
        window.location.href = `/${this.downloadId}`;
      } else {
        this.router.navigateByUrl(`/${this.downloadId}?notRegistered=true`);
        window.location.href = `/${this.downloadId}?notRegistered=true`;
      }
    }
  }

  changeLanguage(language: string) {
    switch (language) {
      case 'en':
        this.selected = 'EN';
        this.language = 'en';
        break;
      case 'fr':
        this.selected = 'FR';
        this.language = 'fr';
        break;
      case 'nl':
        this.selected = 'NL';
        this.language = 'nl';
        break;
      default:
        this.selected = 'NL';
        this.language = 'nl';
    }

    this.translate.use(this.language);
  }

  onChangeLanguage(language: string) {
    this.translate.use(language);
    this.cookieService.set('language', language);
    this.changeLanguage(language);
  }

  showEmailInput() {
    this.emailStep = 'inputEmail';
  }

  sendCode() {
    if (!this.selectedEmail) return;

    this.mainContentService.createExternalToken(uniqueID, this.selectedEmail, this.language, this.downloadId)
      .subscribe({
        next: () => {
          this.emailStep = 'inputCode';
          this.startResendCooldown();
        },
        error: (err) => {
          this.actionsService.set({ type: 'notification', status: 'none', message: '❌ Error sending code' });
        }
      });
  }

  resendCode() {
    if (!this.selectedEmail || this.resendCooldown > 0) return;

    this.mainContentService.createExternalToken(uniqueID, this.selectedEmail, this.language, this.downloadId)
      .subscribe({
        next: () => {
          this.codeInput.reset();
          this.startResendCooldown();
          const message = this.translate.instant('Code resent. Please check your email.');
          this.actionsService.set({ type: 'notification', status: 'none', message: `✅ ${message}` });
        },
        error: (err) => {
          this.actionsService.set({ type: 'notification', status: 'none', message: '❌ Error sending code' });
        }
      });
  }

  private startResendCooldown() {
    this.resendCooldown = this.resendCooldownSeconds;

    interval(1000)
      .pipe(take(this.resendCooldownSeconds), takeUntil(this.destroy$))
      .subscribe({
        next: () => this.resendCooldown--,
      });
  }

  verifyCode() {
    if (!this.selectedEmail || !this.codeInput.value) return;

    this.mainContentService.getToken(uniqueID, this.codeInput.value, false)
      .subscribe({
        next: (response) => {
          if (response) {
            sessionStorage.setItem('authToken', this.codeInput.value + '-' + uniqueID);
            this.showSigningScreen = true;
          }
        },
        error: (error) => {
          let message: string;

          if (error.status === 401) {
            message = this.translate.instant('Incorrect code. Please try again.');
          }
          else {
            message = this.translate.instant('Error verifying code. Please try again.');
          }

          this.actionsService.set({
            type: 'notification',
            status: 'none',
            message: `❌ ${message}`
          });

          this.codeInput.reset();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  handleTokenError(errorData: { status: number }): void {
    this.showSigningScreen = false;
    this.showContent = true;

    this.loadFiles();

    let message: string;

    if (errorData.status === 204) {
      message = this.translate.instant('You are not registered');
      this.actionsService.set({
        type: 'notification',
        status: 'none',
        message: `❌ ${message}`
      });
    }
    else if (errorData.status === 403) {
      message = this.translate.instant('Access expired.');
      this.actionsService.set({
        type: 'notification',
        status: 'none',
        message: `⚠️ ${message}`
      });
    }
    else {
      message = this.translate.instant('Session expired. Please login again.');
      this.actionsService.set({
        type: 'notification',
        status: 'none',
        message: `⚠️ ${message}`
      });
    }
  }
}
